/**
 * Population query builders for Strapi API
 */

/**
 * Population configuration for Services
 * Clean, readable object structure
 */
export const SERVICES_POPULATION = {
  populate: {
    seo: true,
    hero: {
      populate: {
        backgroundImage: true,
      },
    },
    whyChooseUs: {
      populate: {
        items: {
          populate: {
            icon: true,
          },
        },
      },
    },
    servicesList: {
      populate: {
        services: true,
      },
    },
    faqSection: {
      populate: {
        faqs: true,
      },
    },
  },
};

/**
 * Population configuration for About page
 * Clean, readable object structure
 */
export const ABOUT_PAGE_POPULATION = {
  populate: {
    seo: true,
    hero: {
      populate: {
        backgroundImage: true,
      },
    },
    aboutSection: {
      populate: {
        image: true,
      },
    },
    coreValues: {
      populate: {
        values: {
          populate: {
            icon: true,
          },
        },
        backgroundImage: true,
      },
    },
    featuredProjects: {
      populate: {
        projects: {
          populate: {
            image: true,
          },
        },
      },
    },
    partners: {
      populate: {
        partners: {
          populate: {
            logo: true,
          },
        },
      },
    },
    cta: {
      populate: {
        backgroundImage: true,
      },
    },
  },
};

/**
 * Test function to verify qs population generation
 * This can be used for debugging
 */
export function testQsPopulation() {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const qs = require('qs');
  const result = qs.stringify(ABOUT_PAGE_POPULATION, { encode: false });
  console.log('Test qs population generation:', {
    input: ABOUT_PAGE_POPULATION,
    output: result,
    expected:
      'populate[seo]=true&populate[hero][populate][backgroundImage]=true&populate[coreValues][populate][values][populate][icon]=true&populate[featuredProjects][populate][projects][populate][image]=true&populate[partners][populate][logos]=true&populate[cta][populate][backgroundImage]=true',
  });

  return result;
}
